import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IFullArticle } from "@/data/model/Article";
import { Format } from "@/data/util/Format";

import { i18n } from "@/portal/Trans";
import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { ArticleForm } from "@/portal/forms/ArticleForm";
import { ArticleStockSettingsForm } from "@/portal/forms/ArticleStockSettingsForm";
import { TastierGlobal } from "@/portal/globalAccess";
import { UiNotification } from "@/portal/ui/Notification";

export class ArticleController extends BaseTabbedController<IFullArticle> {
    private articleForm: ArticleForm;
    private stockSettingsForm?: ArticleStockSettingsForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).articleDataSource as any);

        this.articleForm = new ArticleForm(this.formContentByTabName("articleedit"));
        this.registerModelForm(this.articleForm);

        this.onActivateTab = (newTab) => {
            if (newTab === "stock") this.showStockSettings();
        };
    }

    protected onModelLoaded(m?: IFullArticle) {
        if (this.copyEntityId != null) {
            UiNotification.showSuccess(i18n("item.itemCopiedAndEditingNow"));
        }

        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        if (m === undefined) this.disableTabs(["stock"]);
        else this.enableTabs(["stock"]);

        this.articleForm.setData(m, this.copyEntityId);
    }

    public showStockSettings() {
        if (this.stockSettingsForm === undefined) {
            this.stockSettingsForm = new ArticleStockSettingsForm(this.formContentByTabName("stock"));
            this.stockSettingsForm.onSaved = (m) => {
                this.model!.stock = m.stock;
                this.model!.isAvailable = m.isAvailable;
                this.articleForm.setFormData(this.model);
            };
        }

        this.stockSettingsForm.setData(this.model, this.copyEntityId);
    }
}
